<template>
  <div class="tech-process">
    <div class="title">
      <span class="iconLeft"></span>
      <h2>评价工作流程</h2>
      <span class="iconRight"></span>
    </div>
    <div class="process-wrapper">
      <div class="process-row">
        <div class="process-col">
          <div class="itemBox">
            <div class="itemNum">01</div>
            <div class="itemText">评价材料形式审查</div>
            <div class="itemTextTwo">核验提交材料完整规范</div>
            <div class="itemTextTwo">确认符合评价准入要求</div>
          </div>
        </div>
        <div class="arrow-box">
          <img src="@/assets/images/arrawRight.png" alt="下一步" />
        </div>
        <div class="process-col">
          <div class="itemBox">
            <div class="itemNum">02</div>
            <div class="itemText">签订委托评价协议</div>
            <div class="itemTextTwo">敲定合作细则</div>
            <div class="itemTextTwo">明确双方权利义务与评价约定</div>
          </div>
        </div>
      </div>
      <div class="process-row process-row-four">
        <div class="process-col">
          <div class="itemBox">
            <div class="itemNum">03</div>
            <div class="itemText">遴选评价专家</div>
            <div class="itemTextTwo">匹配成果领域</div>
            <div class="itemTextTwo">选取专业且无利益关联的评审专家</div>
          </div>
        </div>
        <div class="arrow-box">
          <img src="@/assets/images/arrawRight.png" alt="下一步" />
        </div>
        <div class="process-col">
          <div class="itemBox">
            <div class="itemNum">04</div>
            <div class="itemText">召开科技成果评价会</div>
            <div class="itemTextTwo">组织专家质询研讨</div>
            <div class="itemTextTwo">全面评审成果核心价值</div>
          </div>
        </div>
        <div class="arrow-box">
          <img src="@/assets/images/arrawRight.png" alt="下一步" />
        </div>
        <div class="process-col">
          <div class="itemBox">
            <div class="itemNum">05</div>
            <div class="itemText">作出成果评价结论</div>
            <div class="itemTextTwo">专家合议表决</div>
            <div class="itemTextTwo">形成权威客观的成果评价意见</div>
          </div>
        </div>
        <div class="arrow-box">
          <img src="@/assets/images/arrawRight.png" alt="下一步" />
        </div>
        <div class="process-col">
          <div class="itemBox">
            <div class="itemNum">06</div>
            <div class="itemText">出具成果评价报告</div>
            <div class="itemTextTwo">汇总评审内容</div>
            <div class="itemTextTwo">出具加盖公章的正式评价文书</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped lang="less">
.tech-process {
  padding: 40px 20px; 
  background: #fff;
}

.title {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center; 
  margin-bottom: 50px; 

  h2 {
    font-weight: 800;
    font-size: 30px;
    color: #232323;
    line-height: 24px;
    margin: 0;
  }
}

.iconLeft {
  width: 115px;
  height: 27px;
  margin-right: 17px;
  background-image: url('~@/assets/images/arrowBlue.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: inline-block;
}

.iconRight {
  display: inline-block;
  width: 115px;
  height: 27px;
  margin-left: 17px;
  background: url(~@/assets/images/arrowBlue.png) no-repeat center / cover;
  transform: rotateY(180deg);
}
.process-wrapper {
  width: 100%;
  max-width: 1600px; 
  margin: 0 auto; 
  padding: 0 10px;
}
.process-row {
  display: flex;
  justify-content: center; 
  align-items: center; 
  margin-bottom: 30px;
  width: 100%;

  &:last-child {
    margin-bottom: 0; 
  }
  &.process-row-four {
    flex-wrap: wrap;
  }
}
.process-col {
  flex: 0 0 calc(25% - 20px);
  max-width: 344px; 
  min-width: 280px; 
  .process-row:not(.process-row-four) & {
    flex: 0 0 calc(50% - 20px); 
  }
}
.arrow-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 35px; 
  height: 100%;

  img {
    width: 35px;
    height: 37px;
    flex-shrink: 0; 
  }
}

.itemBox {
  width: 100%; 
  height: 290px;
  padding-top: 45px;
  background: url(~@/assets/images/liuchengicon.png) no-repeat center / contain;
  box-sizing: border-box; 

  .itemNum {
    font-weight: 800;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 30px;
    text-align: center;
  }

  .itemText {
    margin-top: 15px;
    font-weight: bold;
    font-size: 24px;
    color: #232323;
    line-height: 30px;
    text-align: center;
    padding: 0 10px; 
  }

  .itemTextTwo {
    color: #000;
    text-align: center;
    margin-top: 10px;
    font-size: 16px;
    line-height: 22px;
    padding: 0 15px; 
  }
}
@media (max-width: 1400px) {
  .process-col {
    flex: 0 0 calc(33.33% - 20px); 
  }

  .process-row:not(.process-row-four) .process-col {
    flex: 0 0 calc(50% - 20px); 
  }
}
@media (max-width: 1200px) {
  .title h2 {
    font-size: 26px;
  }

  .iconLeft,
  .iconRight {
    width: 80px;
    height: 20px;
  }

  .process-col {
    flex: 0 0 calc(50% - 20px); 
  }

  .itemBox {
    height: 260px;
    padding-top: 35px;

    .itemNum {
      font-size: 26px;
    }

    .itemText {
      font-size: 20px;
      line-height: 26px;
    }

    .itemTextTwo {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .arrow-box img {
    width: 30px;
    height: 32px;
  }
}
@media (max-width: 768px) {
  .title h2 {
    font-size: 22px;
  }

  .iconLeft,
  .iconRight {
    width: 60px;
    height: 18px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .process-row {
    flex-direction: column; 
    gap: 20px; 

    .process-col {
      flex: 0 0 100%; 
      max-width: 320px; 
    }

    .arrow-box {
      transform: rotate(90deg); 
      margin: 10px 0; 
      flex: 0 0 35px; 
    }
  }

  .itemBox {
    height: 250px;
    padding-top: 30px;

    .itemNum {
      font-size: 24px;
    }

    .itemText {
      font-size: 18px;
      line-height: 24px;
    }

    .itemTextTwo {
      font-size: 13px;
      line-height: 18px;
    }
  }

  .arrow-box img {
    width: 25px;
    height: 27px;
  }
}
@media (max-width: 480px) {
  .tech-process {
    padding: 30px 10px;
  }

  .title h2 {
    font-size: 20px;
  }

  .iconLeft,
  .iconRight {
    width: 50px;
    height: 15px;
  }

  .itemBox {
    height: 230px;
    padding-top: 25px;
  }

  .arrow-box img {
    width: 20px;
    height: 22px;
  }
}
</style>